import gql from 'graphql-tag';

export const PAGINATED_FAMILY_THEMES = gql`
  query PaginateFamilyThemes(
    $nextCursor: Int
    $take: Int
    $order: WWS_ThemeOrder
    $colors: [String!]
    $seasons: [String!]
    $styles: [String!]
  ) {
    paginateFamilyThemes(
      nextCursor: $nextCursor
      take: $take
      order: $order
      colors: $colors
      seasons: $seasons
      styles: $styles
    ) {
      results {
        family
        themes {
          categoryData
          designerUrl
          family
          id
          mobilePreviewImage {
            mediaApiId
            mediaUrl
          }
          name
          previewImage {
            mediaApiId
            mediaUrl
          }
          swatchImage {
            mediaApiId
          }
        }
      }
      nextCursor
      hasMore
    }
  }
`;
